
/** QUERY DEFAULTS */
export const PAGINATION = { 
  page: 1, 
  limit: 30 
};

